import React from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import './index.scss';
import { SearchBox } from '../Coveo/search-box';
import { searchBox } from '../Coveo/search-controllers';

type GlobalSearchFieldProps = WithSitecoreContextProps & {
  fields: {
    'Search Hint': Field<string>;
    SearchInfoText: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const GlobalSearchField = ({
  sitecoreContext,
  fields,
}: GlobalSearchFieldProps): React.JSX.Element => {
  return (
    <div className="globalsearchfield">
      {sitecoreContext.pageEditing && (
        <>
          <p>GlobalSearchField Component Edit Mode</p>
        </>
      )}
      <SearchBox
        controller={searchBox}
        fields={{
          'Popup Text': fields.SearchInfoText,
        }}
      />
    </div>
  );
};

export default withSitecoreContext()(GlobalSearchField);
